import { useDnsProviderByNsServers, useNsServers } from 'api/dnsProviders';
import { useEffect, useState } from 'react';
import { useDebounceCallback } from 'usehooks-ts';

const debounceMs = 750;

export const useDebouncedDomainProviderGuide = (domain: string) => {
	const [domainInner, setDomainInner] = useState(domain);
	const setDomainInnerDebounced = useDebounceCallback(
		setDomainInner,
		debounceMs
	);

	useEffect(() => {
		setDomainInnerDebounced(domain);
	}, [domain, setDomainInnerDebounced]);

	const { data } = useNsServers(domain === domainInner ? domainInner : null);

	return useDnsProviderByNsServers(data);
};
